module.exports = __webpack_public_path__ + "media/svg-new/down-arrow-b30beeab.svg";